import { render, staticRenderFns } from "./PageTAXIS.vue?vue&type=template&id=2035348a"
import script from "./PageTAXIS.vue?vue&type=script&lang=js"
export * from "./PageTAXIS.vue?vue&type=script&lang=js"
import style0 from "./PageTAXIS.vue?vue&type=style&index=0&id=2035348a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports